import { inject, Injectable, Injector } from '@angular/core';
import { TuiDialogService } from '@taiga-ui/core';
import { PolymorpheusComponent } from '@taiga-ui/polymorpheus';

import { ChatAccessingDialogComponent } from '../chat-accessing-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class ChatAccessingDialogService {
  private readonly dialogService = inject(TuiDialogService);
  private readonly injector = inject(Injector);

  open() {
    return this.dialogService.open<boolean>(new PolymorpheusComponent(ChatAccessingDialogComponent, this.injector), {
      closeable: false,
      dismissible: true,
      size: 'm',
    });
  }
}
